'use client'
import 'swiper/css'

import { motion } from 'motion/react'
import { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import { AdvancedButton } from '../atoms/AdvancedButton'
import Icon from '../atoms/Icons'

/**
 *
 * @returns: En sektion med galleri.
 * @example: <GallerySection />
 * @alias: GallerySection
 * @module: components/sections/GallerySection
 * @summary: Denne komponent bruges til at oprette en ny sektion med galleri.
 * @see: src/components/sections/GallerySection.tsx
 * @version: 1.0.0
 * @property: [sectiom]
 * @author: Kasper Buchholtz
 *
 **/

interface CarouselProps {
  spaceBetween?: number
  slidesPerView?: number
  children: any
  breakpoints?: {
    [key: number]: {
      slidesPerView: number
      spaceBetween: number
    }
  }
}

const Carousel = ({
  spaceBetween,
  slidesPerView,
  breakpoints,
  children,
}: CarouselProps) => {
  const swiperRef = useRef(null)
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
      className="relative w-full col-span-full"
    >
      <Swiper
        ref={swiperRef}
        spaceBetween={spaceBetween}
        slidesPerView={1}
        breakpoints={breakpoints}
        onSlideChange={() => console.log('slide change')}
        onSwiper={(swiper) => console.log(swiper)}
        className="w-full !py-8"
      >
        {children.map((child, index) => (
          <SwiperSlide
            className="!h-auto odd:min-h-[calc(100%_-_12px)] md:odd:py-6"
            key={index}
          >
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.div>
  )
}

export default Carousel
